module.exports = __webpack_public_path__ + "static/media/appstore.7ec0af72.png";